type HasTitle = {
  title?: string
}

type HasMenuOrder = {
  menuOrder?: number
}

export type SortMode = 'none' | 'title' | 'menuOrder' | 'idOrder'

export const sortByTitle = <T extends HasTitle>(a: T, b: T) => {
  const fa = (a.title ?? '').toLocaleLowerCase('nb-NO')
  const fb = (b.title ?? '').toLocaleLowerCase('nb-NO')

  if (fa < fb) return -1
  if (fa > fb) return 1
  return 0
}

export const sortByMenuOrder = <T extends HasMenuOrder>(a: T, b: T) =>
  (a.menuOrder ?? 0) - (b.menuOrder ?? 0)

/**
 * Preserves the order from the ACF select field (ID list).
 */
export function sortByAcf<T extends { id: number }>(
  items: T[],
  order?: number[]
): T[] {
  if (!order?.length) return items

  const map = new Map(items.map(item => [item.id, item]))

  return order
    .map(id => map.get(id))
    .filter(Boolean) as T[]
}

/**
 * Default: 'none' (preserve API order).
 */
export const sortItems =
  (mode: SortMode = 'none', idOrder?: number[]) =>
    <T extends HasTitle & HasMenuOrder & { id: number }>(items: T[]): T[] => {
      if (mode === 'none') return items
      if (mode === 'title') return [...items].sort(sortByTitle)
      if (mode === 'menuOrder') return [...items].sort(sortByMenuOrder)
      if (mode === 'idOrder') return sortByAcf(items, idOrder)
      return items
    }
